import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { resetDataUploadFile, uploadFileThunk } from "redux/Reducers/Concierge/uploadFileSlicer";
import { approveProposedQuotationThunk, resetApproveProposedQuotationData } from "redux/Reducers/Concierge/approveProposedQuotation";

import "Assets/styles/default/components/Concierge/Modals/QuotationApprovalModal.less";

import { Col, Form, Row, Upload, VertButton, VertCheckbox, VertInput, VertModal, VertTypography, notification } from "@vertem-core/vertice-ds";
import { useForm } from "antd/es/form/Form";

const QuotationApprovalModal = (props) => {
  const { isOpen, setIsOpen, withTerm, solicitationId, quotationId, quotationProductIds, onSuccess, stepBeforeRedemption, setResponse2FA } = props;

  const [ form ] = useForm();

  const dispatch = useDispatch();

  const [hasNote, setHasNote] = useState(false);
  const [termUrl, setTermUrl] = useState(null);

  const {
    dataUploadFile,
    loadingUploadFile,
    errorUploadFile
  } = useSelector(
    (state) => state.UploadFile
  );

  const {
    approvalData,
    isApprovalLoading,
    approvalHasError,
    errorsApproval
  } = useSelector(
    (state) => state.ApproveProposedQuotation
  );

  const validators = {
    note: {
      rules: [
        {
          required: true,
          message: "Campo obrigatório.",
        }
      ]
    }
  }

  const handleTermChange = async ({ file, onSuccess, onError }) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await dispatch(uploadFileThunk(formData)).unwrap();
      onSuccess(response, file);
    } catch (error) {
      onError(error);

      notification.error({
        message: "Houve um erro durante o envio do termo.",
      });
    }
  };

  const handleTermRemove = () => {
    setTermUrl(null);
  }

  const approvalDisableConditions = () => {
    if (withTerm && !termUrl) return true;
  }

  const handleSubmit = () => {
    const fieldsToValidate = hasNote ? ["note"] : [];

    form.validateFields(fieldsToValidate)
      .then((values) => {
        if (!solicitationId) return;

        const { note } = values;

        const approval = {
          withTerm,
          solicitationId,
          quotationId,
          quotationProductIds,
          note: hasNote ? note : "n/i",
        };

        if (withTerm) approval.termUrl = termUrl;

        dispatch(approveProposedQuotationThunk(approval));
      })
      .catch(() => {
        notification.error({
          message: "Preencha os campos corretamente.",
        });
      });
  }

  useEffect(() => {
    if (dataUploadFile) setTermUrl(dataUploadFile);
  }, [dataUploadFile]);

  useEffect(() => {
    if (!approvalData) return;

    notification.success({
      message: stepBeforeRedemption ? "Resgate foi aprovado." : "Cotação foi aprovada."
    })

    setIsOpen(false);
    onSuccess(approvalData);
  }, [approvalData])

  useEffect(() => {
    if (!errorUploadFile) return;

    notification.error({
      message: "Houve um erro ao enviar termo, tente novamente.",
    });

    dispatch(resetDataUploadFile());
  }, [errorUploadFile]);

  useEffect(() => {
    if (!approvalHasError) return;

    const errorCode = errorsApproval.responseData?.code;

    if (errorCode?.includes('326')) {
      notification.error({
        message: errorsApproval.responseData.message
      });
    } else if (errorCode?.includes('406')) {
      setResponse2FA(errorsApproval);
    } else {
      notification.error({
        message: "Houve um erro ao aprovar etapa, tente novamente."
      });
    }

    dispatch(resetApproveProposedQuotationData());
  }, [approvalHasError]);

  return (
    <VertModal
      className="concierge-quotation-approval-modal"
      width={"50%"}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      destroyOnClose={true}
    >
      <Row>
        <Col>
          <VertTypography.Title>
            {stepBeforeRedemption ? "Você aprova este resgate?" : "Você aprova esta cotação?"}
          </VertTypography.Title>
        </Col>
      </Row>

      <Row className="note-container">
        <Col span={24}>
          <VertCheckbox
            className="note-checkbox"
            checked={hasNote}
            onChange={() => setHasNote(!hasNote)}
          >
            Adicionar comentário
          </VertCheckbox>
        </Col>

        {
          hasNote && (
            <Col span={24}>
              <Form form={form}>
                <Form.Item
                  name="note"
                  rules={validators.note.rules}
                >
                  <VertInput.TextArea
                    className="note"
                    placeholder="Adicione um comentário"
                  />
                </Form.Item>
              </Form>
            </Col>
          )
        }
      </Row>

      <Row className="action-btn-group" justify="space-between">
        <Col>
          {
            withTerm && ( 
              <Upload 
                className="btn-term-upload" 
                customRequest={handleTermChange}
                onRemove={handleTermRemove}
              >
                <VertButton
                  className="button-concierge"
                  loading={loadingUploadFile}
                >
                  Anexar Termo
                </VertButton>
              </Upload>
            )
          }
        </Col>

        <Col className="next-step-btn">
          <VertButton
            className="button-concierge"
            type="default"
            onClick={() => setIsOpen(false)}
          >
            Não
          </VertButton>

          <VertButton
            className="btn-approve"
            type="highlight"
            loading={isApprovalLoading}
            disabled={approvalDisableConditions()}
            onClick={handleSubmit}
          >
            Sim
          </VertButton>
        </Col>
      </Row>
    </VertModal>
  );
}

export default QuotationApprovalModal;
